import React from 'react';
import * as Actions from '../../../actions/operatingStatistics';
import ReactEcharts from 'echarts-for-react';
import weibo from './images/wb-ico-a.png';
import weixin from './images/wx-ico-a.png';
import red from './images/red.png';
import blue from './images/blue.png';
import './fansInfo.scss';

class FansInfo extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            xAxisData: [],
            yAxisData: {},
            wbFans: 0,
            wbFollow: 0,
            wxFans: 0
        }
    }

    componentDidMount(){
        let xAxisData = [];
        let increaseData = [];
        let decreaseData = [];
        Actions.findFansCountNow({},(res) => {
            this.setState({
                wbFans:res["wb-fans-count"],
                wbFollow: res["wb-follow-count"],
                wxFans: res["wx-fans-count"]
                 
            })
        })
        Actions.findWx7DaysFansVariation({},(res) => {
            if(res.data){
                res.data.map((item, index) => {
                    xAxisData.push(item.name);
                    increaseData.push(item.add);
                    decreaseData.push(item.reduce);
                })
                this.setState({
                    xAxisData,
                    yAxisData: { increaseData, decreaseData }
                })
            }
        })   
    }

    getOptions = () => {
        const options = {
            title: {
                text: '粉丝增减趋势',
                textStyle: {
                    color: '#000',
                    fontWeight:'normal',
                    fontSize: 14
                }
            },
            tooltip:{
                trigger: 'axis'
            },
            legend: {
                data: ['新增', '减少']
            },
            color: ['#4696ef', '#ea898b'],
            grid:{
                top: 60,
                bottom: 30,
            },
            xAxis: {
                name: '时间',
                type: 'category',
                splitLine: {
                    show: false,
                },
                // axisLine:{
                //     show: false
                // },
                data: this.state.xAxisData 
            },
            yAxis: {
                name: '粉丝（个）',
                type: 'value',
                splitLine: {
                    show: false,
                },
             
                // axisLine:{
                //     show: false
                // },
                minInterval: 1,
            },
            series : [
                {
                    name: '新增',
                    type: 'line',
                    data: this.state.yAxisData.increaseData ? this.state.yAxisData.increaseData : []
                },
                {
                    name: '减少',
                    type: 'line',
                    data: this.state.yAxisData.decreaseData ? this.state.yAxisData.decreaseData: []
                }
            ]
        }
        return options
    }

    render(){
        const { wbFans, wbFollow, wxFans} = this.state;
        return(
            <div className="fans-info">
                <div className="fans-info-title">新媒体粉丝数统计</div>
                <div className="fans-info-content">
                    <div className="fans-info-content-left">
                        <div>
                            <img src={weibo} alt="" />
                            <span>微博</span>
                        </div>
                        <div>
                            <img src={red} alt="" />
                            <span>粉丝数</span>
                            <span>{wbFans}</span>
                        </div>
                        <div>
                            <img src={blue} alt="" />
                            <span>关注数</span>
                            <span>{wbFollow}</span>
                        </div>
                    </div>
                    <div className="fans-info-content-right">
                        <div className="fans-info-content-right-wx">
                            <div>
                                <img src={weixin} alt="" />
                                <span>微信</span>
                            </div>
                            <div>
                                <span>粉丝数</span>
                                <span>{wxFans}</span>
                            </div>
                        </div>
                        <div className="fans-info-content-right-echarts">
                        <ReactEcharts
                            option={this.getOptions()}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{width: '100%', height: '100%'}}
                        />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FansInfo;